var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMemberPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 26C10.2691 26 10.4729 25.897 10.5446 25.8593C10.6438 25.8072 10.7309 25.7466 10.799 25.6952C10.9373 25.5906 11.0841 25.4574 11.2295 25.3147C11.5249 25.0247 11.8887 24.6219 12.2907 24.139C13.0978 23.1695 14.1019 21.8253 15.0834 20.2967C16.0641 18.7693 17.0348 17.0383 17.7633 15.2969C18.4865 13.568 19 11.7613 19 10.1023C19 5.08724 14.9825 1 10 1C5.0175 1 1 5.08724 1 10.1023C1 11.7613 1.5135 13.568 2.23675 15.2969C2.96523 17.0383 3.93593 18.7693 4.91658 20.2967C5.89807 21.8253 6.9022 23.1695 7.70928 24.139C8.11132 24.6219 8.47507 25.0247 8.77047 25.3147C8.91588 25.4574 9.06267 25.5906 9.201 25.6952C9.26912 25.7466 9.35622 25.8072 9.45543 25.8593C9.52711 25.897 9.7309 26 10 26Z",
    fill: "#8D11C8",
    stroke: "white",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 4,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberPin);
export default __webpack_public_path__ + "static/media/memberPin.e02e264a64ff2484b604f9ea3e5baf52.svg";
export { ForwardRef as ReactComponent };